<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">Duplicar {{ item }} recetas</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="duplicateRecipe" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12 class="d-flex">
                <v-select
                  :label="$t('recipes.labels.restaurant')"
                  v-model="form.data.restaurant"
                  :items="restaurants"
                  :rules="validation.restaurant"
                  item-text="name"
                  item-value="_id"
                  @change="loadData"
                />
              </v-flex>
              <v-flex xs12 md12 class="d-flex">
                <v-select
                  :disabled="areas.disabled"
                  @change="activeSection"
                  :label="$t('recipes.labels.area')"
                  v-model="form.data.area"
                  :items="areas.data"
                  :rules="validation.area"
                  item-text="name"
                  item-value="_id"
                  return-object
                />
              </v-flex>
              <v-flex xs12 md12 class="d-flex">
                <v-select
                  :disabled="sections.disabled"
                  :label="$t('recipes.labels.section')"
                  v-model="form.data.section"
                  :items="sections.data"
                  :rules="validation.section"
                  item-text="name"
                  item-value="_id"
                  return-object
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeDialog">
          {{ $t('recipes.close') }}
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          rounded
          small
          depressed
          @click="submit">
          {{ $t('recipes.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import { required, string, object } from 'vue-mc/validation'

export default {
  props: {
    item: {
      type: Number
    },
    recipes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          restaurant: null,
          section: null,
          area: null,
          recipes: []
        }
      },
      sections: {
        data: [],
        disabled: true
      },
      areas: {
        data: [],
        disabled: true
      },
      validation: {
        area: [required.and(object.or(string))],
        section: [required.and(object.or(string))]
      }
    }
  },
  computed: {
    units: function () {
      return this.$store.state.login.units.data || []
    },
    restaurants: function () {
      return this.$store.state.login.restaurants.data || []
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetRecipeForm()
      }
    }
  },
  methods: {
    async activeSection () {
      const sectionsResponse = await this.$api.get(`/v1/restaurants/${this.form.data.restaurant}/sections`, { area: this.form.data.area._id })
      this.sections.data = sectionsResponse.data
      this.sections.disabled = false
    },
    submit: async function () {
      this.$refs.duplicateRecipe.validate()
      if (this.form.valid) {
        this.overlay = true
        try {
          const payload = cloneDeep(this.form.data)
          payload.area = (this.form.data.area || {}).id
          payload.section = (this.form.data.section || {}).id
          await this.$api.post(`/v1/recipes/duplicate-multiple`, payload)
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    resetRecipeForm () {
      this.form.data = {
        recipes: this.recipes.map(x => x.uuid)
      }
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    async loadData (restaurant) {
      const areasResponse = await this.$api.get(`/v1/restaurants/${restaurant}/areas`)
      this.areas.data = areasResponse.data
      this.areas.disabled = false
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
